import React, { useContext } from 'react';
import { Header, List } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../../../atoms/Image';
import MarkdownField from '../../../../../../components/MarkdownContent';
import { GatsbyImagePropType, MenuItemVariationPropType } from '../../../../../../services/proptypes';
import { MenuContext } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import { ModifierSetsBasic } from '../../modifiers';
import ItemInteraction from '../ItemInteraction';
import ItemVariations from '../ItemVariations';
import './ItemHorizontalCard.css';
var defaultProps = {
  description: null,
  image: null,
  imageAltText: '',
  className: '',
  gatsbyImage: {},
  variations: []
};
export default function ItemHorizontalCard(_ref) {
  var id = _ref.id,
    name = _ref.name,
    description = _ref.description,
    image = _ref.image,
    imageAltText = _ref.imageAltText,
    gatsbyImage = _ref.gatsbyImage,
    variations = _ref.variations,
    onClick = _ref.onClick,
    className = _ref.className;
  var _useContext = useContext(MenuContext),
    items = _useContext.items,
    modifierSets = _useContext.modifierSets,
    disableModifiers = _useContext.disableModifiers,
    precision = _useContext.precision,
    displayZeroCostItemPrices = _useContext.displayZeroCostItemPrices,
    displayZeroCostModifierPrices = _useContext.displayZeroCostModifierPrices;
  var item = MenuUtil.getItemById(items, id);
  var itemModifierSetIds = item.modifierSets;
  var itemModifierSets = MenuUtil.getItemModifierSets(itemModifierSetIds, modifierSets);
  return /*#__PURE__*/React.createElement(List.Item, {
    className: "item-horizontal-card ".concat(className),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-container"
  }, /*#__PURE__*/React.createElement(Header, {
    as: "h3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "header-text"
  }, name), " ", /*#__PURE__*/React.createElement(ItemInteraction, {
    item: item
  })), /*#__PURE__*/React.createElement(ItemVariations, {
    variations: variations,
    precision: precision,
    displayZeroCostItemPrices: displayZeroCostItemPrices
  })), /*#__PURE__*/React.createElement(MarkdownField, {
    style: {
      marginBottom: '0.25rem'
    },
    className: "markdown"
  }, description), !disableModifiers && /*#__PURE__*/React.createElement(ModifierSetsBasic, {
    modifierSets: itemModifierSets,
    displayZeroCostModifierPrices: displayZeroCostModifierPrices
  })), (!_isEmpty(image) || !_isEmpty(gatsbyImage)) && /*#__PURE__*/React.createElement(Image, {
    src: gatsbyImage && gatsbyImage.childImageSharp || "".concat(image),
    className: "item-horizontal-card-image",
    altText: imageAltText
  }));
}
ItemHorizontalCard.defaultProps = defaultProps;